import React from "react";
import { AppBar, Toolbar, Box } from "@mui/material";

import logo from "../assets/logo.png";

export default function Header() {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: "#f6c812",
        top: 0,
        margin: 0,
        padding: 0
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: "56px !important",
          padding: "0 16px !important",
          margin: 0
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Mealno Logo"
          sx={{
            height: 30,
            width: "auto",
            objectFit: "contain",
          }}
        />
      </Toolbar>
    </AppBar>
  );
}